import { render, staticRenderFns } from "./RelatedRecipeList.vue?vue&type=template&id=54d1f966&"
import script from "./RelatedRecipeList.vue?vue&type=script&lang=ts&"
export * from "./RelatedRecipeList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports